// src/directives/debounce.js
export default {
  inserted(el, binding) {
    const { value, arg, modifiers } = binding
    let delay = 500
    let immediate = false

    // 获取延迟时间
    if (arg) delay = parseInt(arg)
    if (modifiers.immediate) immediate = true

    // 防抖函数
    const debounce = (func, wait) => {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          timeout = null
          if (!immediate) func.apply(this, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(this, args)
      }
    }

    // 处理原生点击事件
    const originalHandler = el.onclick || (() => {})
    const debouncedHandler = debounce((e) => {
      // 检查按钮是否禁用
      if (!el.disabled && !el.classList.contains('is-disabled')) {
        if (typeof value === 'function') {
          value(e)
        } else if (typeof originalHandler === 'function') {
          originalHandler(e)
        }
      }
    }, delay)

    el.addEventListener('click', debouncedHandler)

    // 保存引用以便清理
    el._debouncedHandler = debouncedHandler
  },

  unbind(el) {
    if (el._debouncedHandler) {
      el.removeEventListener('click', el._debouncedHandler)
    }
  }
}
